module.exports = __webpack_public_path__ + "img/hr-concrete-inner-corner-mask.d727826b.png";